import { gqlFilterOperator } from '@minecraft.graphql-types';
import { initialRadioButtonSkillLevelValue, emptyOption } from '../../../shared/config';
import { FiltersNameEnum, RangeEnum, SizesChildrenCategoryEnum } from '../../../shared/types';

// This is the initial form data for the search filters for Reps
// These are common between Talent Scout and Talent Search
export const repsCommonInitialData = {
  // Basic filters
  [FiltersNameEnum.stageName]: '',
  [FiltersNameEnum.gender]: [],
  [FiltersNameEnum.additionallyIdentifiesAs]: [],
  [FiltersNameEnum.ethnicAppearance]: [],
  [FiltersNameEnum.playableAgeRange]: {
    [FiltersNameEnum.switchTo]: false,
    [FiltersNameEnum.min]: '',
    [FiltersNameEnum.max]: '',
    type: RangeEnum.age,
  },
  [FiltersNameEnum.workingLocation]: [],
  [FiltersNameEnum.workPermitExpiration]: {
    [FiltersNameEnum.min]: '',
    [FiltersNameEnum.max]: '',
    type: RangeEnum.date,
  },
  // Unions And Reps
  [FiltersNameEnum.nonUnion]: false,
  [FiltersNameEnum.unionStatus]: [],
  [FiltersNameEnum.excludeUnionStatus]: [],
  // Custom
  [FiltersNameEnum.isNewTalent]: false,
  // Appearances
  [FiltersNameEnum.heightRange]: {
    [FiltersNameEnum.switchTo]: false,
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.height, // need to build pill of height range
  },
  [FiltersNameEnum.weightRange]: {
    [FiltersNameEnum.switchTo]: false,
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.weight, // need to build pill of weight range
  },
  [FiltersNameEnum.hairColor]: [],
  [FiltersNameEnum.willingToHairColor]: false,
  [FiltersNameEnum.hairStyle]: [],
  [FiltersNameEnum.willingToHairStyle]: false,
  [FiltersNameEnum.facialHair]: [],
  [FiltersNameEnum.willingToFacialHair]: false,
  [FiltersNameEnum.eyeColor]: [],
  [FiltersNameEnum.tattoosList]: [],
  [FiltersNameEnum.tattoosNote]: '',
  [FiltersNameEnum.piercingsList]: [],
  [FiltersNameEnum.piercingsNote]: '',
  [FiltersNameEnum.uniqueAttributes]: [],
  [FiltersNameEnum.multipleBirth]: [],
  [FiltersNameEnum.otherExperience]: '',
  [FiltersNameEnum.pregnancyDueDateRange]: {
    [FiltersNameEnum.min]: '',
    [FiltersNameEnum.max]: '',
    type: RangeEnum.date, // need to build pill of age range
  },
  // Role Preferences
  [FiltersNameEnum.rolePreferences]: [],
  // Clothing Sizes
  [FiltersNameEnum.sizesCategory]: emptyOption,
  [FiltersNameEnum.sizesChildrenCategory]: {
    value: SizesChildrenCategoryEnum.boys,
    label: 'Boys',
  },
  [FiltersNameEnum.chest]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.neck]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.sleeve]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.coat]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.waist]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.inseam]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.glove]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.hat]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.menTShirt]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.menShoes]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.menShoeWidth]: emptyOption,
  [FiltersNameEnum.dress]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.bust]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.underbust]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.cup]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.hip]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.womenPants]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.womenTShirt]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.womenShoes]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.womenShoeWidth]: emptyOption,
  [FiltersNameEnum.boys]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.girls]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.toddlers]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.infants]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.childrenShoes]: {
    [FiltersNameEnum.min]: emptyOption,
    [FiltersNameEnum.max]: emptyOption,
    type: RangeEnum.size,
  },
  [FiltersNameEnum.childrenShoeWidth]: emptyOption,
  // Skills And Assets
  [FiltersNameEnum.skills]: [],
  [FiltersNameEnum.skillLevels]: initialRadioButtonSkillLevelValue,
  [FiltersNameEnum.skillOperator]: {
    value: gqlFilterOperator.OR,
    label: 'Any',
  },
  [FiltersNameEnum.dogBreed]: [],
  [FiltersNameEnum.dogBreedSize]: '',
  [FiltersNameEnum.otherAnimals]: [],
  [FiltersNameEnum.props]: [],
  [FiltersNameEnum.sportsEquipment]: [],
  [FiltersNameEnum.wardrobe]: [],
  [FiltersNameEnum.profession]: '',
  [FiltersNameEnum.vehicleType]: emptyOption,
  [FiltersNameEnum.vehicleYearRange]: {
    [FiltersNameEnum.min]: '',
    [FiltersNameEnum.max]: '',
  },
  [FiltersNameEnum.vehicleMake]: emptyOption,
  [FiltersNameEnum.vehicleModel]: '',
  // Documents
  [FiltersNameEnum.documents]: [],
  [FiltersNameEnum.profileListIds]: [],
};
